export let getSharedCurrentLanguageKey = () => {
  throw new Error("sharedCurrentLanguageKey not set");
};
export function setSharedCurrentLanguageKeyCallback(callback) {
  getSharedCurrentLanguageKey = callback;
}